import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import SaveIcon from '@material-ui/icons/SaveAlt';

import DataTable from 'Components/DataTable/DataTable';
import { downloadFile } from 'Actions/submission';
import { load, updateFilter } from 'Actions/submissionReviewer';
import { formatDate, getAttachmentTitle } from 'Utils';
import { DataTableMetadataType, QueryFilterType } from 'Types';
import {
    DATA_TABLE_COLUMN_TYPE_ACTIONS,
    DATA_TABLE_COLUMN_TYPE_DATE,
    DATA_TABLE_COLUMN_TYPE_FORMATTED_MESSAGE,
    INVITATION_STATUS_INVITED, ROLE_CHIEF_EDITORIAL,
} from 'Constants';
import { aclDecorator } from 'Decorators';

@connect(
    store => ({
        data: store.submissionReviewersList.data,
        filter: store.submissionReviewersList.filter,
        defaultFilter: store.submissionReviewersList.defaultFilter,
        metadata: store.submissionReviewersList.metadata,
    }),
    dispatch => ({
        downloadFile: (fileId, title, saveToLog) => dispatch(downloadFile(fileId, title, saveToLog)),
        loadReviewers: (round, filter) => dispatch(load(round, filter)),
        updateReviewersFilter: (round, filter) => dispatch(updateFilter(round, filter)),
    })
)
@aclDecorator()
export default class ReviewRoundReports extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        round: PropTypes.number.isRequired,
        data: PropTypes.object.isRequired,
        filter: QueryFilterType.isRequired,
        metadata: DataTableMetadataType.isRequired,
        defaultFilter: QueryFilterType.isRequired,
        customFilter: PropTypes.object.isRequired,
        loadReviewers: PropTypes.func.isRequired,
        updateReviewersFilter: PropTypes.func.isRequired,
        downloadFile: PropTypes.func.isRequired,
        is: PropTypes.func.isRequired,
    };

    /**
     *
     * @type {{customFilter: {}}}
     */
    static defaultProps = {
        customFilter: {},
    };

    getFilter() {
        const { round, filter, defaultFilter, customFilter } = this.props;

        return (filter[round] ? filter[round] : defaultFilter)
            .merge(customFilter, { deep: true })
            .merge({ where: { submission_review_round_id: round }, reload: filter.reload }, { deep: true });
    }

    getColumns = () => {
        const { downloadFile, is } = this.props;

        return [
            {
                key: 'invite.name',
                col: { width: '25%' },
                title: 'data_table.reviewer',
                sortable: true,
            },
            {
                key: 'invite.email',
                col: { width: '15%' },
                title: 'data_table.reviewer_email',
                sortable: true,
            },
            {
                key: 'invite.created_at',
                col: { width: '15%' },
                title: 'data_table.invitation_date',
                type: DATA_TABLE_COLUMN_TYPE_DATE,
                sortable: true,
            },
            {
                key: 'invite.status',
                col: { width: '10%' },
                title: 'data_table.invitation_status',
                sortable: true,
                type: DATA_TABLE_COLUMN_TYPE_FORMATTED_MESSAGE,
                prefix: 'types.status',
            },
            {
                key: 'invite.updated_at',
                col: { width: '10%' },
                title: 'data_table.response_date',
                sortable: true,
                handler: item => {
                    return item.invite.status === INVITATION_STATUS_INVITED ? '' : formatDate(item.invite.updated_at);
                },
            },
            {
                key: 'attachment',
                col: { width: '10%' },
                title: 'data_table.report',
                type: DATA_TABLE_COLUMN_TYPE_ACTIONS,
                actions: [
                    {
                        name: 'Download',
                        icon: <SaveIcon />,
                        onClick: item => {
                            const fileTitle = item.attachment ? getAttachmentTitle(item.attachment) : '';
                            downloadFile(item.attachment.id, fileTitle, !is(ROLE_CHIEF_EDITORIAL));
                        },
                    },
                ],
            },
            {
                key: 'attachment.created_at',
                col: { width: '15%' },
                title: 'data_table.report_date',
                type: DATA_TABLE_COLUMN_TYPE_DATE,
            },
        ];
    };

    render() {
        const { data, loadReviewers, metadata, updateReviewersFilter, round } = this.props;

        return (
            <DataTable
                columns={this.getColumns()}
                metadata={metadata[round] ? metadata[round] : {}}
                data={data[round] ? data[round] : []}
                filter={this.getFilter()}
                load={filter => loadReviewers(round, filter)}
                updateFilter={filter => updateReviewersFilter(round, filter)}
                icon={false}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/containers/ReviewRoundReports.jsx